import BroadcastModal from './BroadcastModal.component';

export default BroadcastModal;
